<template>
  <div>
    <div class="headerFiltle">
      <div class="headFileitem">
        <div class="BrandSel" @click.stop="showBrand($event)">
          <span style="margin-left:10px;margin-right:5px">品牌:</span>
          <p>{{brand}}</p>
          <i class="el-icon-arrow-down" style="margin-right:10px"></i>
        </div>
        <div class="BrandSel" @click="hideOther($event)">
          <el-date-picker
            v-model="endTime"
            type="month"
            placeholder="请选择月"
            :editable="false"
            :clearable="false"
            style="width:100px"
            format="yyyy-MM"
            value-format="yyyyMM"
            :picker-options="pickerOptions"
            @change="changeMonth"
          ></el-date-picker>
        </div>
        <div class="BrandSel" @click.stop="showBrand2($event)">
          <span style="margin-left:10px;margin-right:5px">品类:</span>
          <p>{{selCateGory1Cn}}</p>
          <i class="el-icon-arrow-down" style="margin-right:10px"></i>
        </div>
      </div>

      <div class="headerHistory" v-show="BrandFlag">
        <span class="history_tie" style="background: transparent;">选择品牌:</span>
        <span
          v-for="item in option1"
          :key="item.value"
          class="history_tie"
          :class="{history_Active:item.text==brand}"
          @click.stop="changeValue(item.text)"
        >{{item.text}}</span>
      </div>
      <div class="headerHistory" v-show="BrandFlag2">
        <span class="history_tie" style="background: transparent;">选择品类:</span>
        <span
          v-for="item in option2"
          :key="item.value"
          class="history_tie"
          :class="{history_Active:item.value==selCateGory1}"
          @click.stop="changeValue2(item.value,item.text)"
        >{{item.category1Cn}}</span>
      </div>
    </div>

    <div class="main">
      <Industry
        :ChangeFlag="MtYFlag"
        :senToOverView="{BrandSel:brand,CateGory1Sel:selCateGory1,startTime:startTime,endTime:endTime}"
        :SelCat1Cn="selCateGory1Cn"
        @chinaName="getChinaName"
      ></Industry>
      <div class="conTit" style="margin:10px 0">
        <span></span>
        <p>{{selCateGory2Cn}} 品牌榜</p>
        <p class="conTitAb" @click="changeFlag()">
          <b :class="{conTitAbAct:MtYFlag}">年度数据</b>
          <b :class="{conTitAbAct:!MtYFlag}">月度数据</b>
        </p>
      </div>
      <div class="industy_table">
        <div class="tableHead">
          <van-row>
            <van-col span="2">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="7">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="5">
              <img src="../../assets/jpg/GMV.png" alt style="width:13px;height:13px" />市场GMV
            </van-col>
            <van-col span="5">
              <img src="../../assets/jpg/GMV同比.png" alt style="width:13px;height:13px" />市场同比
            </van-col>
            <van-col span="5">
              <img src="../../assets/jpg/市场份额.png" alt style="width:13px;height:13px" />市场份额
            </van-col>
          </van-row>
        </div>
        <div class="tableBody">
          <van-row v-for="(item,i) in tableData1" :key="i">
            <van-col span="3" :class="i<1?'table_top':i>=2?' table_bot':' table_mid'">
              <span style="position: relative;">
                No.
                <br />
                <i
                  :class="item.rank>item.lyRank?'el-icon-bottom':item.rank<item.lyRank?'el-icon-top':'el-icon-minus'"
                  style="position: absolute;top:18px;left:0px;font-size:10px"
                >{{item.rank}}</i>
              </span>
            </van-col>
            <van-col span="1">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="7" style="text-align:left;overflow:hidden">{{item.brandName}}</van-col>
            <van-col span="5">{{item.salesEn}}</van-col>
            <van-col span="4">{{item.growth}}</van-col>
            <van-col span="4">{{item.share}}</van-col>
            <div style="width:90%;height:0.5px;background: #CDCDD1;padding-left:20%"></div>
          </van-row>
        </div>
      </div>
      <div class="conTit" style="margin:10px 0">
        <span></span>
        <p>{{selCateGory2Cn}} 渠道分析</p>
        <p class="conTitAb" @click="changeFlag()">
          <b :class="{conTitAbAct:MtYFlag}">年度数据</b>
          <b :class="{conTitAbAct:!MtYFlag}">月度数据</b>
        </p>
      </div>
      <div class="industry_echarts">
        <van-row>
          <van-col span="24">
            <div id="IndEcharts"></div>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="tableHead">
              <van-row>
                <van-col span="3">
                  <div style="opacity: 0;">1</div>
                </van-col>
                <van-col span="11">渠道</van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV.png" alt style="width:13px;height:13px" />市场GMV
                </van-col>
                <van-col span="5">
                  <img src="../../assets/jpg/GMV同比.png" alt style="width:13px;height:13px" />市场同比
                </van-col>
              </van-row>
            </div>
            <div class="tableBody">
              <van-row v-for="(item,i) in tableData2" :key="i">
                <van-col span="3" :class="i<1?'table_top':i>=2?' table_bot':' table_mid'">No.{{i+1}}</van-col>
                <van-col span="11">{{item.platform + item.shopType}}</van-col>
                <van-col span="5">{{item.salesEn}}</van-col>
                <van-col span="5">{{item.growth}}</van-col>
                <div style="width:90%;height:0.5px;background: #CDCDD1;padding-left:20%"></div>
              </van-row>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import Industry from "@/components/ButFo_Radar/public/Industry_Overview ";
import { mapActions, mapState, createLogger } from "vuex";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 - 2592000000 - 2592000000;
        },
      },
      brand: "",
      selCateGory1: "",
      selCateGory1Cn: "",
      selCateGory2: "",
      selCateGory2Cn: "",
      option1: [],
      option2: [],
      tableData1: [],
      tableData2: [],
      BrandList: [],
      BrandList2: [],
      MtYFlag: true,
      BrandFlag: false,
      BrandFlag2: false,
      startTime: "",
      endTime: "",
      PlatFormChartsLeng: [],
      PlatFormChartsData: [],
    };
  },
  methods: {
    drawEcharts() {
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{a}{b}{c}{d}",
        },
        legend: {
          show: true,
          orient: "vertical",
          right: "0%",
          top: "10%",
          data: this.PlatFormChartsLeng,
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10,
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },
        tooltip: {
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          formatter: "{a} : {c0}%",
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF",
          },
        },
        series: [
          {
            name: "占比",
            type: "pie",
            radius: "75%",
            center: ["25%", "50%"],
            data: this.PlatFormChartsData,
            label: {
              normal: {
                position: "inner",
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
          },
        ],
      };
      let myChart = this.$echarts.init(document.getElementById("IndEcharts"));
      myChart.setOption(option);
    },
    getChinaName(data) {
      this.selCateGory2Cn = data;
    },
    hideOther(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      this.BrandFlag2 = false;
      this.BrandFlag = false;
    },
    showBrand(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      $(e.currentTarget).siblings(".BrandSel").removeClass("industry_footAct");
      this.BrandFlag = !this.BrandFlag;
      this.BrandFlag2 = false;
    },
    showBrand2(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      $(e.currentTarget).siblings(".BrandSel").removeClass("industry_footAct");
      this.BrandFlag2 = !this.BrandFlag2;
      this.BrandFlag = false;
    },
    changeMonth(data) {
      if (this.MtYFlag) {
        this.startTime = data.slice(0, 4) + "01";
        this.endTime = data;
        this.$store.dispatch("getMonthFrom", data.slice(0, 4) + "01");
        this.$store.dispatch("getMonthTo", data);
      } else {
        this.startTime = data;
        this.endTime = data;
        this.$store.dispatch("getMonthFrom", data);
        this.$store.dispatch("getMonthTo", data);
      }
    },
    changeFlag() {
      this.MtYFlag = !this.MtYFlag;
      this.getMonth();
      this.$store.dispatch("getFlag", this.MtYFlag);
    },
    changeValue(text) {
      this.brand = text;
      this.$store.dispatch("getBrand", this.brand);
      this.getBrand2();
      this.BrandFlag = false;
    },
    changeValue2(value, text) {
      this.selCateGory1 = value;
      this.selCateGory1Cn = text;
      this.$store.dispatch("getCateGory1", this.selCateGory1);
      this.BrandFlag2 = false;
    },
    getBrand() {
      this.$addr
        .post("/radar/getBrand", qs.stringify({ platForm: "", cateGory: "" }))
        .then((res) => {
          this.option1 = [];
          this.BrandList = [];
          this.BrandList = res.data.data;
          this.BrandList.map((item, index) => {
            this.option1.push(
              Object.assign({}, item, {
                text: item.brandNameEn,
                value: item.brandNameEn,
              })
            );
          });
          this.brand = this.BrandList[2].brandNameEn;
          this.$store.dispatch("getBrand", this.brand);
          this.getBrand2();
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getBrand2() {
      this.$addr
        .post(
          "/radar/getCateGory1",
          qs.stringify({ platForm: "", brand: this.brand })
        )
        .then((res) => {
          this.BrandList2 = res.data.data;
          this.option2 = [];
          this.BrandList2.map((item, index) => {
            this.option2.push(
              Object.assign({}, item, {
                text: item.category1Cn,
                value: item.category1,
              })
            );
          });
          this.selCateGory1 = this.BrandList2[0].category1;
          this.selCateGory1Cn = this.BrandList2[0].category1Cn;
          this.$store.dispatch("getCateGory1", this.selCateGory1);
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getMonth() {
      this.$addr
        .post("/radar/getUpdateDate")
        .then((res) => {
          if (this.MtYFlag) {
            this.startTime = res.data.data[0].startDate;
          } else {
            this.startTime = res.data.data[0].yyyymm;
          }
          this.endTime = res.data.data[0].yyyymm;
          this.$store.dispatch("getMonthFrom", this.startTime);
          this.$store.dispatch("getMonthTo", this.endTime);
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getBrandTable() {
      this.$addr
        .post(
          "/radar/getTopBrand",
          qs.stringify({
            platForm: "",
            cateGory1: this.selCateGory1,
            cateGory2: this.selCateGory2,
            monthFrom: this.startTime,
            monthTo: this.endTime,
            brand: this.brand,
          })
        )
        .then((res) => {
          this.tableData1 = res.data.data;
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
    getPlatFormTable() {
      this.$addr
        .post(
          "/radar/getSumPlatForm",
          qs.stringify({
            platForm: "",
            cateGory1: this.selCateGory1,
            cateGory2: this.selCateGory2,
            monthFrom: this.startTime,
            monthTo: this.endTime,
            brand: this.brand,
          })
        )
        .then((res) => {
          this.tableData2 = res.data.data;
          this.PlatFormChartsLeng = [];
          this.PlatFormChartsData = [];
          res.data.data.map((item, index) => {
            this.PlatFormChartsLeng.push(item.platform + item.shopType);
            this.PlatFormChartsData.push(
              Object.assign({}, item, {
                name: item.platform + item.shopType,
                value: [parseFloat(item.share)],
              })
            );
          });
          // this.PlatFormChartsData.push({
          //       name: item.platform + item.shopType,
          //       data: [parseFloat(item.share)],
          //     });
          console.log(this.PlatFormChartsData);
          this.drawEcharts();
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
  },
  components: {
    Industry,
  },
  created() {
    this.getBrand();
    this.getMonth();
    let _ = require("lodash");
    this.setOneGet = _.debounce(this.getBrandTable, 500); // 此处getSearchCompanyCityInfo是在methods中定义的函数， 500单位为毫秒，延迟500毫秒再调用，下同
    this.setTwoGet = _.debounce(this.getPlatFormTable, 500);
    this.setThrGet = _.debounce(this.getBrandTable, 500);
  },
  computed: {
    ...mapState([
      "monthFrom",
      "monthTo",
      "Brand",
      "CateGory1",
      "CateGory2",
      "MyFlag",
    ]),
  },
  watch: {
    Brand(currVal) {
      this.setOneGet();
      this.setTwoGet();
    },
    CateGory2(currVal) {
      this.selCateGory2 = currVal;
      this.setOneGet();
      this.setTwoGet();
    },
    monthFrom(currVal) {
      this.setThrGet();
      this.setTwoGet();
    },
    monthTo(currVal) {
      this.setThrGet();
      this.setTwoGet();
    },
  },
};
</script>
<style scoped>
.tableHead {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #5d5d5d;
  letter-spacing: 0;
}

.tableBody {
  text-align: center;
  line-height: 55px;
  border-bottom: 1px solid #ccc;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-y: hidden;
}
.table_top {
  background: #9a3231;
  color: #fff;
  border-radius: 0 5px 5px 0;
  height: 45px;
  line-height: 27px;
}
.table_mid {
  color: #fff;
  background: #ba4d4c;
  border-radius: 0 5px 5px 0;
  height: 45px;
  line-height: 27px;
}
.table_bot {
  color: #fff;
  background: #d58a89;
  border-radius: 0 5px 5px 0;
  height: 45px;
  line-height: 27px;
}
.industry span {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.main {
  margin-top: 90px;
  padding: 10px;
}
.headFileitem {
  width: 100%;
  overflow: scroll;
  display: flex;
}
.headerFiltle {
  background: #faf1e7;
  padding: 20px 0;
  margin-bottom: 10px;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
/deep/.el-input__inner {
  background: rgb(89, 91, 102) !important;
}
.headerHistory {
  top: 15px;
  position: relative;
  height: 66px;
  background-color: #fff;
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  align-items: center;
}

.headerHistory span {
  margin: auto 10px;
  font-family: "SourceHanSansCN-Bold";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
}

.history_tie {
  padding: 0px 5px;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  min-width: 80px;
  text-align: center;
  overflow-y: scroll;
  background: #fff8f1;
  border-radius: 13px;
}
.history_Active {
  background: #f6e7d4;
}
.industry_footAct {
  position: relative;
  background-color: #f6e7d4 !important;
  border: 3px solid #d9b17e !important;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
}
.BrandSel {
  border: 1px solid #ccc;
  z-index: 5;
  background: #faf1e7;
  box-shadow: 0 3px 20px 0 rgba(192, 168, 139, 0.3);
  border-radius: 10px;
  min-width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "SourceHanSansCN-Light";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 10px;
}
/deep/ .el-input .el-input__inner {
  background: #faf1e7 !important;
}
.industry_echarts {
  padding: 10px;
  border-radius: 15px;
  min-height: 200px;
  margin-bottom: 20px;
  background: #faf1e7;
  box-shadow: 0 10px 30px 0 rgba(178, 180, 190, 0.5);
  border-radius: 20px;
}
#IndEcharts {
  width: 100%;
  min-height: 200px;
}
.conTit {
  margin-left: 8%;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #555555;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.conTitAb {
  width: 130px;
  position: absolute;
  right: 23px;
  line-height: 21px;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.conTitAb b {
  font-family: "SourceHanSansCN-ExtraLight";
  font-size: 14px;
  color: #484781;
  letter-spacing: 0;
  text-align: center;
  line-height: 29px;
}
.conTitAbAct {
  font-family: "SourceHanSansCN-Bold";
  color: #494949 !important;
  border-bottom: 2px solid #494949;
}
.industy_table {
  background: #faf1e7;
  box-shadow: 0 10px 30px 0 rgba(178, 180, 190, 0.5);
  border-radius: 25px;
  min-height: 300px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/Industry_Radar.vue